import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import TableSmall from '../../Theme/TableSmall';
import '../../modal.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const emptySupport = { id: null, name: '', phone: '' };

const columns = (onEdit, onDelete) => [
  {
    Header: 'Support Name',
    accessor: 'name',
    disableFilters: true,
  },
  {
    Header: 'Phone Number',
    accessor: 'phone',
    disableFilters: true,
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    disableFilters: true,
    Cell: ({ row }) => (
      <div>
        <Button size="sm" variant="info" onClick={() => onEdit(row.original)} style={{ marginRight: 8 }}>
          Edit
        </Button>
        <Button size="sm" variant="danger" onClick={() => onDelete(row.original)}>
          Delete
        </Button>
      </div>
    ),
  },
];

const AdditionalSupportForm = ({ showModal, hideModal }) => {
  const [supports, setSupports] = useState([]);
  const [currentSupport, setCurrentSupport] = useState(emptySupport);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  // Fetch supports from backend
  const fetchSupports = async () => {
    try {
      const { data } = await axios.get('/additional-supports');
      setSupports(data);
    } catch (err) {
      toast.error('Failed to load supports');
    }
  };

  useEffect(() => {
    fetchSupports();
  }, []);

  // Open modal for add
  useEffect(() => {
    if (showModal) {
      setEditMode(false);
      setCurrentSupport(emptySupport);
      setError(null);
      setModalOpen(true);
    }
  }, [showModal]);

  // Open modal for edit
  const handleEdit = (support) => {
    setEditMode(true);
    setCurrentSupport(support);
    setError(null);
    setModalOpen(true);
  };

  // Close modal
  const handleClose = () => {
    setModalOpen(false);
    setCurrentSupport(emptySupport);
    setError(null);
    setEditMode(false);
    if (hideModal) hideModal();
  };

  // Handle input change
  const handleChange = (e) => {
    setCurrentSupport({ ...currentSupport, [e.target.name]: e.target.value });
  };

  // Add or update support
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentSupport.name || !currentSupport.phone) {
      setError('Both fields are required.');
      return;
    }
    try {
      if (editMode) {
        await axios.put(`/additional-supports/${currentSupport.id}`, {
          name: currentSupport.name,
          phone: currentSupport.phone,
        });
        toast.success('Support updated successfully.');
      } else {
        await axios.post('/additional-supports', {
          name: currentSupport.name,
          phone: currentSupport.phone,
        });
        toast.success('Support added successfully.');
      }
      fetchSupports();
      handleClose();
    } catch (err) {
      toast.error('Failed to save support.');
    }
  };

  // Delete support
  const handleDelete = async (support) => {
    if (!window.confirm('Are you sure you want to delete this support?')) return;
    try {
      await axios.delete(`/additional-supports/${support.id}`);
      toast.success('Support deleted successfully.');
      fetchSupports();
    } catch (err) {
      toast.error('Failed to delete support.');
    }
  };

  return (
    <div>
      <TableSmall columns={columns(handleEdit, handleDelete)} data={supports} />
      <Modal
        style={{ marginTop: '60px' }}
        show={modalOpen}
        onHide={handleClose}
        backdrop={false}
        keyboard={false}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title>{editMode ? 'Edit Additional Support' : 'Add Additional Support'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="form-group">
              <label htmlFor="support_name">Name</label>
              <input
                type="text"
                className="form-control"
                id="support_name"
                name="name"
                value={currentSupport.name}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="support_phone">Phone Number</label>
              <input
                type="text"
                className="form-control"
                id="support_phone"
                name="phone"
                value={currentSupport.phone}
                onChange={handleChange}
              />
            </div>
            {error && <div className="error" style={{ color: 'red' }}>{error}</div>}
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                {editMode ? 'Update' : 'Save'}
              </Button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AdditionalSupportForm; 